import { schema } from 'normalizr';
import userSchema from './user';
import orgSchema from './org';
import { SCHEMA_TYPE_DATA_MAPS } from '../constants/schemaTypes';

const dataMapSchema = new schema.Entity(SCHEMA_TYPE_DATA_MAPS, {
  owner: userSchema,
  org: orgSchema,
});

export default dataMapSchema;
